import { render, staticRenderFns } from "./AttributeComponent.vue?vue&type=template&id=3a833e79"
import script from "./AttributeComponent.vue?vue&type=script&lang=js"
export * from "./AttributeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports